import { I18n } from "../services/I18n";
import "./generated/site-translations-pt-BR";
import common_ptBR from "../../../../../libs/ps/restaumatic-common/locales/pt-BR.json";
import core_types_sites_ptBR from "../../../../../libs/ps/restaumatic-core-types-sites/locales/pt-BR.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  "pt-BR": { _core_types_sites: core_types_sites_ptBR },
});
I18n.translations = I18n.extend(I18n.translations, {
  "pt-BR": { _common: common_ptBR },
});
